// extracted by mini-css-extract-plugin
module.exports = {"progressColor":"#8d90e0","primaryColor":"#6a4a9e","green":"#5bc1a4","whyUsTitle":"#2e2e2e","whyUsItemTitle":"#000","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453"};